import controller from './address.controller';
import templateBase from './templates/address-base.view.html';
import templateT15 from './templates/address-t15.view.html';
import templateAD from './templates/address-adaptative.html';

let AddressComponent = {
    template: changeTemplate,
    controller,
    bindings : {
        shCtrl : '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');

    if(__env.adaptative) {
        return templateAD;
    } else { 
        if (response.ADDRESS.component == 'template_t15') { return templateT15; }
        else {
          return templateBase;
        }
    }
}

export default AddressComponent;


/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/address/address.component.js
 **/